<template>
  <div>
    <FormKit
      type="hidden"
      :name="`components[${index}][component_type]`"
      :value="component.component_type"
    />

    <FormKit
      label="Titel"
      type="text"
      :name="`components[${index}][title]`"
      :value="component.title"
      @input="value => update('title', value)"
    />

    <div class="d-flex align-items-center justify-content-between mb-3">
      <div>
        <span class="font-weight-bold">Reviews</span>
      </div>

      <div>
        <button type="button" class="btn btn-primary" @click="add">Add</button>
      </div>
    </div>

    <div class="py-4 border-top" v-for="(review, reviewIndex) in reviews" :key="reviewIndex">
    <div class="mb-2 d-flex align-items-center justify-content-between">
        <div>
          <span class="font-weight-bold"> Review #{{ reviewIndex + 1 }} </span>
        </div>

        <div>
          <button
            type="button"
            class="btn btn-danger"
            @click="remove(reviewIndex)"
          >
            X
          </button>
        </div>
      </div>

      <FormKit
        type="text"
        :name="`components[${index}][reviews][${reviewIndex}][name]`"
        v-model="review.name"
      />

      <FormKit
        label="Review omschrijving"
        type="textarea"
        :name="`components[${index}][reviews][${reviewIndex}][description]`"
        v-model="review.description"
      />

      <FormKitImage
        label="Afbeelding"
        :name="`components[${index}][reviews][${reviewIndex}][image]`"
        v-model="review.image"
      />

      <FormKit
        label="Tour link"
        type="text"
        :name="`components[${index}][reviews][${reviewIndex}][tour_link]`"
        v-model="review.tour_link"
      />

      <FormKit
        label="Tour naam"
        type="text"
        :name="`components[${index}][reviews][${reviewIndex}][tour]`"
        v-model="review.tour"
      />

      <FormKit
        label="Champagnehuis link"
        type="text"
        :name="`components[${index}][reviews][${reviewIndex}][maison_link]`"
        v-model="review.maison_link"
      />

      <FormKit
        label="Champagnehuis naam"
        type="text"
        :name="`components[${index}][reviews][${reviewIndex}][maison]`"
        v-model="review.maison"
      />
    </div>
  </div>
</template>

<script>
import mixin from "../mixins/component";

export default {
  name: "PageReviewSlider",
  mixins: [mixin],
  data() {
    return {
      reviews: [...Object.values(this.modelValue?.reviews ?? {})],
    };
  },
  methods: {
    add() {
      this.reviews.push({
        name: "",
        description: "",
        image: "",
        tour_link: "",
        tour: "",
        maison_link: "",
        maison: "",
      });
    },
    remove(index) {
        this.reviews.splice(index, 1)
    }
  },
  watch: {
    reviews: {
      deep: true,
      handler(reviews) {
        this.update("reviews", reviews);
      },
    },
  },
};
</script>
